import API from '../utils/api';
import { ENDPOINT_URL } from '../constants/defaultValues';

const getMarketGroups = async params => {
    try {
        const res = await API.get(`${ENDPOINT_URL}/market/groups`, {
            params,
        });

        return res.data;
    } catch (error) {
        console.error(error);
    }
};

const MarketGroupService = {
    getMarketGroups,
};

export default MarketGroupService;
